export function getPagesFromFile(file) {
  if (!file) return [];
  const { document: doc } = file;
  if (!doc) return [];
  return doc.children.filter((node) => node.type === 'CANVAS');
}
